import { Component, OnInit } from '@angular/core';
import { EditbaseComponent } from '../../editbase.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/services/message.service';
import { NavigationNodeService } from 'src/app/services/navigation/navigation-node.service';
import { SubmenuService } from '../../submenu/submenu.service';
import { UserSearchSettingService } from 'src/app/services/search/user-search-setting.service';

@Component({
  selector: 'app-user-search-setting-form',
  templateUrl: './user-search-setting-form.component.html',
  styleUrls: ['./user-search-setting-form.component.less']
})
export class UserSearchSettingFormComponent extends EditbaseComponent implements OnInit {


  model:any = {
    SearchFields:[]
  };

  currentProperty:any = {
    FieldType:1
  };

  activetab :string = "basic-info";

  constructor(private activatedRoute: ActivatedRoute, private router:Router, public userSearchSettingService: UserSearchSettingService, public messageService:MessageService, 
    public submenuService:SubmenuService, public translate: TranslateService) { 

      super();
    }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.params.id;

    if(id>0)
    {
      this.messageService.showLoading();
      this.userSearchSettingService.loadById(id).subscribe((data:any) => {
        this.model = data;
        this.messageService.hideLoading();
      });
    }
  }

  setActiveTab(tabName:string){
    this.activetab  = tabName;
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/navigation/nodes", this);  
  }

  save() {
  this.messageService.showLoading();
   this.userSearchSettingService.save(this.model).subscribe(
    (data:any) => {

      this.model = data;
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");

    },  
    err =>{
      this.messageService.hideLoading();
      this.messageService.showMessage("Error: "+err, "error");
    }
  );
  }

  delete() {
    this.messageService.showLoading();
    this.userSearchSettingService.delete(this.model).subscribe((data:any) => {
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");
      this.router.navigate(['usersearchsetting']);
    });
  }

  addProperty(){
    if(this.currentProperty.PropertyPath!=null && this.currentProperty.PropertyPath.length>0){

      if(this.model.SearchFields==undefined || this.model.SearchFields == null){
        this.model.SearchFields = [];
      }

      this.model.SearchFields.push(this.currentProperty);


      this.currentProperty = {FieldType: 1};
    }
  }

  deleteProperty(index){
    this.model.SearchFields.splice(index, 1);
  }
}